import React, { ReactNode } from "react";
import { StaticImageData } from "next/image";
import { twMerge } from "tailwind-merge";
import UserImage from "../UserImage/UserImage";
import { UserLink } from "@/app/(components)/Application/User/UserLink";
import { ShortUser } from "@/api/users/types";
import { ImagePlaceholder } from "../Image/types";
import { EndemicUserWrapper } from "../EndemicUserWrapper";

export interface Props {
  user: ShortUser;
  name?: string;
  image?: Partial<StaticImageData>;
  imagePlaceholder?: ImagePlaceholder;
  subtitle?: ReactNode;
  className?: string;
  subtitleClassName?: string;
  small?: boolean;
  imageClassName?: string;
}

const UserBasicData = ({
  user,
  name,
  image,
  imagePlaceholder,
  subtitle,
  className,
  subtitleClassName,
  small,
  imageClassName,
}: Props) => {
  return (
    <div className={twMerge("flex items-center min-w-0", className)}>
      <UserLink artist={user} tooltipPosition={["right", "middle"]}>
        <UserImage
          name={name}
          image={image}
          imagePlaceholder={imagePlaceholder}
          small={small}
          className="shrink-0"
          imgClassName={imageClassName}
        />
      </UserLink>
      <div
        className={twMerge(
          "ml-8 text-ellipsis overflow-hidden",
          small && "ml-4",
        )}
      >
        <EndemicUserWrapper id={user.id} className="mr-1 gap-x-1">
          <UserLink
            artist={user}
            tooltipPosition={["right", "middle"]}
            className={twMerge(
              "text-body-2 mb-1 lg:mb-0 overflow-hidden text-ellipsis",
              !small && "lg:text-body-1",
              small && "text-body-3",
            )}
          >
            {name}
          </UserLink>
        </EndemicUserWrapper>
        <div
          className={twMerge(
            "text-body-3 text-secondary endemic:text-primary overflow-hidden text-ellipsis",
            small && "text-[14px] leading-4", //TODO: use tailwind class
            subtitleClassName,
          )}
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
};

export default UserBasicData;
